import * as i0 from '@angular/core';
import { PLATFORM_ID, Injectable, Inject, Component, Input, EventEmitter, NgModule } from '@angular/core';
import * as i1 from '@angular/cdk/platform';
import { PlatformModule } from '@angular/cdk/platform';
import * as i4 from '@angular/common';
import { isPlatformBrowser, DOCUMENT, CommonModule, isPlatformServer } from '@angular/common';
function StarComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 2);
    i0.ɵɵelement(2, "path", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function StarComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 4);
    i0.ɵɵelement(1, "path", 5);
    i0.ɵɵelementEnd();
  }
}
const _c0 = a0 => ({
  "background-image": a0
});
const _c1 = () => [0, 1, 2, 3, 4];
function NgxSmartBannerComponent_div_8_app_star_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "app-star", 10);
  }
  if (rf & 2) {
    const i_r1 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("solid", ctx_r1.reviewAverage <= i_r1);
  }
}
function NgxSmartBannerComponent_div_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8);
    i0.ɵɵtemplate(1, NgxSmartBannerComponent_div_8_app_star_1_Template, 1, 1, "app-star", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpureFunction0(1, _c1));
  }
}
const _c2 = ".smartbanner[_ngcontent-%COMP%]{box-sizing:border-box;text-shadow:none;position:absolute;top:0;left:0;z-index:99999;padding:0 10px;width:100%;height:84px;display:flex;justify-content:space-between;align-items:center;background:#f3f3f3;font-family:Helvetica,sans,sans-serif}.smartbanner__exit[_ngcontent-%COMP%]{position:relative;display:block;margin-right:14px;background-color:#f3f3f3;width:12px;height:12px;border:0;text-align:center}.smartbanner__exit[_ngcontent-%COMP%]:after, .smartbanner__exit[_ngcontent-%COMP%]:before{position:absolute;top:0;width:1px;height:12px;background:#767676;content:\"\"}.smartbanner__exit[_ngcontent-%COMP%]:before{transform:rotate(45deg)}.smartbanner__exit[_ngcontent-%COMP%]:after{transform:rotate(-45deg)}.smartbanner__icon[_ngcontent-%COMP%]{width:64px;height:64px;border-radius:15px;background-size:64px 64px}.smartbanner__info[_ngcontent-%COMP%]{margin-left:8px;display:flex;flex-direction:column;justify-content:space-between;width:45%;height:64px;color:#767676}.smartbanner__info--title[_ngcontent-%COMP%]{font-size:14px;color:#000}.smartbanner__info--rating[_ngcontent-%COMP%]{display:flex;margin:3px 0}.smartbanner__info--author[_ngcontent-%COMP%], .smartbanner__info--price[_ngcontent-%COMP%]{font-size:12px}.smartbanner__button[_ngcontent-%COMP%]{display:block;padding:0 10px;min-width:10%;background:#f3f3f3;color:#1474fc;font-size:14px;font-weight:700;text-align:center;text-decoration:none}.smartbanner__button__label[_ngcontent-%COMP%]{text-align:center}.smartbanner.smartbanner--android[_ngcontent-%COMP%]{background:#3d3d3d url(\"data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7\")}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]{margin-right:0;width:18px;height:17px;border-radius:14px;background:#1c1e21;box-shadow:inset 0 1px 2px rgba(0,0,0,.8),0 1px 1px hsla(0,0%,100%,.3);color:#b1b1b3;font-family:ArialRoundedMTBold,Arial;font-size:20px;line-height:17px;text-shadow:0 1px 1px #000}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:after, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:before{top:3px;left:8px;width:2px;height:11px;background:#b1b1b3}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:hover{color:#eee}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__icon[_ngcontent-%COMP%]{background-color:transparent;box-shadow:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info[_ngcontent-%COMP%]{color:#ccc}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info--title[_ngcontent-%COMP%]{color:#fff;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]{color:#fff;background:#3eacc3;padding:5px 10px;border:2px solid #fff;min-width:12%;font-size:14px;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:hover{background:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]{display:block;padding:0 10px;background:#42b6c9;background:linear-gradient(180deg,#42b6c9,#39a9bb);box-shadow:none;line-height:24px;text-align:center;text-transform:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:hover{background:#2ac7e1}.star-rating[_ngcontent-%COMP%]{font-size:12px;color:#e19620;margin-right:2px}";
let CookieService = /*#__PURE__*/(() => {
  class CookieService {
    constructor(platformId, document) {
      this.document = document;
      this.isBrowser = isPlatformBrowser(platformId);
    }
    check(key) {
      if (!this.isBrowser) {
        return false;
      }
      return this.isBrowser && this.document.cookie.includes(key);
    }
    set(key, value, until = null) {
      if (!this.isBrowser) {
        return;
      }
      const untilUTC = until === null || until === void 0 ? void 0 : until.toUTCString();
      const expires = untilUTC ? `; expires=${(until === null || until === void 0 ? void 0 : until.toUTCString()) || ''}` : '';
      this.document.cookie = `${key}=${value}${expires}; path=/; SameSite=Strict`;
    }
    get(key) {
      if (!this.isBrowser) {
        return '';
      }
      const match = this.document.cookie.match(new RegExp(`(^| )${key}=([^;]+)`));
      return (match === null || match === void 0 ? void 0 : match[2]) || null;
    }
    deleteAll() {
      if (!this.isBrowser) {
        return;
      }
      this.document.cookie = '';
    }
  }
  CookieService.ɵfac = function CookieService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CookieService)(i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(DOCUMENT));
  };
  CookieService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CookieService,
    factory: CookieService.ɵfac,
    providedIn: 'root'
  });
  return CookieService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let StarComponent = /*#__PURE__*/(() => {
  class StarComponent {}
  StarComponent.ɵfac = function StarComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || StarComponent)();
  };
  StarComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: StarComponent,
    selectors: [["app-star"]],
    inputs: {
      solid: "solid"
    },
    standalone: false,
    decls: 3,
    vars: 2,
    consts: [["regular", ""], [4, "ngIf", "ngIfElse"], ["width", "16px", "height", "16px", "viewBox", "0 0 1792 1792", "xmlns", "http://www.w3.org/2000/svg"], ["fill", "orange", "d", "M1201 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zm527-357q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"], ["width", "16px", "height", "16px", "xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 576 512", 1, "star-rating"], ["fill", "orange", "d", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"]],
    template: function StarComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, StarComponent_ng_container_0_Template, 3, 0, "ng-container", 1)(1, StarComponent_ng_template_1_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const regular_r1 = i0.ɵɵreference(2);
        i0.ɵɵproperty("ngIf", ctx.solid)("ngIfElse", regular_r1);
      }
    },
    dependencies: [i4.NgIf],
    styles: [".smartbanner[_ngcontent-%COMP%]{box-sizing:border-box;text-shadow:none;position:absolute;top:0;left:0;z-index:99999;padding:0 10px;width:100%;height:84px;display:flex;justify-content:space-between;align-items:center;background:#f3f3f3;font-family:Helvetica,sans,sans-serif}.smartbanner__exit[_ngcontent-%COMP%]{position:relative;display:block;margin-right:14px;background-color:#f3f3f3;width:12px;height:12px;border:0;text-align:center}.smartbanner__exit[_ngcontent-%COMP%]:after, .smartbanner__exit[_ngcontent-%COMP%]:before{position:absolute;top:0;width:1px;height:12px;background:#767676;content:\"\"}.smartbanner__exit[_ngcontent-%COMP%]:before{transform:rotate(45deg)}.smartbanner__exit[_ngcontent-%COMP%]:after{transform:rotate(-45deg)}.smartbanner__icon[_ngcontent-%COMP%]{width:64px;height:64px;border-radius:15px;background-size:64px 64px}.smartbanner__info[_ngcontent-%COMP%]{margin-left:8px;display:flex;flex-direction:column;justify-content:space-between;width:45%;height:64px;color:#767676}.smartbanner__info--title[_ngcontent-%COMP%]{font-size:14px;color:#000}.smartbanner__info--rating[_ngcontent-%COMP%]{display:flex;margin:3px 0}.smartbanner__info--author[_ngcontent-%COMP%], .smartbanner__info--price[_ngcontent-%COMP%]{font-size:12px}.smartbanner__button[_ngcontent-%COMP%]{display:block;padding:0 10px;min-width:10%;background:#f3f3f3;color:#1474fc;font-size:14px;font-weight:700;text-align:center;text-decoration:none}.smartbanner__button__label[_ngcontent-%COMP%]{text-align:center}.smartbanner.smartbanner--android[_ngcontent-%COMP%]{background:#3d3d3d url(\"data:image/gif;base64,R0lGODlhCAAIAIABAFVVVf///yH5BAEHAAEALAAAAAAIAAgAAAINRG4XudroGJBRsYcxKAA7\")}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]{margin-right:0;width:18px;height:17px;border-radius:14px;background:#1c1e21;box-shadow:inset 0 1px 2px rgba(0,0,0,.8),0 1px 1px hsla(0,0%,100%,.3);color:#b1b1b3;font-family:ArialRoundedMTBold,Arial;font-size:20px;line-height:17px;text-shadow:0 1px 1px #000}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:after, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:before{top:3px;left:8px;width:2px;height:11px;background:#b1b1b3}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__exit[_ngcontent-%COMP%]:hover{color:#eee}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__icon[_ngcontent-%COMP%]{background-color:transparent;box-shadow:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info[_ngcontent-%COMP%]{color:#ccc}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__info--title[_ngcontent-%COMP%]{color:#fff;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]{color:#fff;background:#3eacc3;padding:5px 10px;border:2px solid #fff;min-width:12%;font-size:14px;font-weight:700}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button[_ngcontent-%COMP%]:hover{background:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]{display:block;padding:0 10px;background:#42b6c9;background:linear-gradient(180deg,#42b6c9,#39a9bb);box-shadow:none;line-height:24px;text-align:center;text-transform:none}.smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:active, .smartbanner.smartbanner--android[_ngcontent-%COMP%]   .smartbanner__button__label[_ngcontent-%COMP%]:hover{background:#2ac7e1}.star-rating[_ngcontent-%COMP%]{font-size:12px;color:#e19620;margin-right:2px}"]
  });
  return StarComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxSmartBannerComponent = /*#__PURE__*/(() => {
  class NgxSmartBannerComponent {
    constructor(platform, cookieService) {
      this.platform = platform;
      this.cookieService = cookieService;
      this.onClose = new EventEmitter();
      if (this.platform.ANDROID) {
        this.modifier = 'android';
      }
      if (this.platform.IOS) {
        this.modifier = 'ios';
      }
    }
    /**
     * Gets icon
     */
    get icon() {
      var _a, _b, _c, _d;
      if (this.platform.ANDROID) {
        return (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.icon) === null || _b === void 0 ? void 0 : _b.android;
      }
      if (this.platform.IOS) {
        return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.icon) === null || _d === void 0 ? void 0 : _d.ios;
      }
      return null;
    }
    /**
     * Gets button url
     */
    get buttonUrl() {
      var _a, _b, _c, _d;
      if (this.platform.ANDROID) {
        return (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.buttonUrl) === null || _b === void 0 ? void 0 : _b.android;
      }
      if (this.platform.IOS) {
        return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.buttonUrl) === null || _d === void 0 ? void 0 : _d.ios;
      }
      return '#';
    }
    /**
     * Gets price suffix
     */
    get priceSuffix() {
      var _a, _b;
      if (this.platform.ANDROID) {
        return (_a = this.settings.priceSuffix) === null || _a === void 0 ? void 0 : _a.android;
      }
      if (this.platform.IOS) {
        return (_b = this.settings.priceSuffix) === null || _b === void 0 ? void 0 : _b.ios;
      }
      return '';
    }
    /**
     * Set cookie to reminder value and destroy component
     */
    exit() {
      this.cookieService.set('smartbanner_closed', '1', this.endDate('exit'));
      this.onClose.emit();
      this.componentRef.destroy();
    }
    /**
     * Set cookie to hidden value and destroy component
     *
     * @author Roy Freij <roy@bsbip.com>
     */
    view() {
      this.cookieService.set('smartbanner_closed', '1', this.endDate('view'));
      this.onClose.emit();
      this.componentRef.destroy();
    }
    /**
     * Gets end date
     */
    endDate(type) {
      const date = new Date();
      if (!this.settings.daysReminder) {
        return null;
      }
      const timeToLive = type === 'exit' ? this.settings.daysHidden : this.settings.daysReminder;
      date.setDate(date.getDate() + (timeToLive || 0));
      return date;
    }
    /**
     * Gets review rating
     *
     * @author Harry Apperloo <harry@bsbip.com>
     */
    get reviewAverage() {
      var _a, _b, _c, _d;
      if (this.platform.ANDROID) {
        return (_b = (_a = this.settings) === null || _a === void 0 ? void 0 : _a.rating) === null || _b === void 0 ? void 0 : _b.android;
      }
      if (this.platform.IOS) {
        return (_d = (_c = this.settings) === null || _c === void 0 ? void 0 : _c.rating) === null || _d === void 0 ? void 0 : _d.ios;
      }
      return 5;
    }
  }
  NgxSmartBannerComponent.ɵfac = function NgxSmartBannerComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxSmartBannerComponent)(i0.ɵɵdirectiveInject(i1.Platform), i0.ɵɵdirectiveInject(CookieService));
  };
  NgxSmartBannerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: NgxSmartBannerComponent,
    selectors: [["nc-ngx-smart-banner"]],
    inputs: {
      settings: "settings",
      componentRef: "componentRef"
    },
    standalone: false,
    decls: 13,
    vars: 16,
    consts: [[1, "smartbanner__exit", 3, "click"], [1, "smartbanner__icon", 3, "ngStyle"], [1, "smartbanner__info"], [1, "smartbanner__info--title"], [1, "smartbanner__info--author"], ["class", "smartbanner__info--rating", 4, "ngIf"], [1, "smartbanner__info--price"], ["target", "_blank", "rel", "noopener", 1, "smartbanner__button", 3, "click", "href"], [1, "smartbanner__info--rating"], [3, "solid", 4, "ngFor", "ngForOf"], [3, "solid"]],
    template: function NgxSmartBannerComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "button", 0);
        i0.ɵɵlistener("click", function NgxSmartBannerComponent_Template_button_click_1_listener() {
          return ctx.exit();
        });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "div", 1);
        i0.ɵɵelementStart(3, "div", 2)(4, "div", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtext(7);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(8, NgxSmartBannerComponent_div_8_Template, 2, 2, "div", 5);
        i0.ɵɵelementStart(9, "div", 6);
        i0.ɵɵtext(10);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(11, "a", 7);
        i0.ɵɵlistener("click", function NgxSmartBannerComponent_Template_a_click_11_listener() {
          return ctx.view();
        });
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd()();
      }
      if (rf & 2) {
        i0.ɵɵclassMap(i0.ɵɵinterpolate1("smartbanner smartbanner--", ctx.modifier));
        i0.ɵɵadvance();
        i0.ɵɵattribute("aria-label", ctx.settings.closeLabel);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(14, _c0, "url(" + ctx.icon + ")"));
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate1(" ", ctx.settings.title, " ");
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.settings.author, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.settings.hideRating && ctx.reviewAverage);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate2(" ", ctx.settings.price, "", ctx.priceSuffix, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("href", i0.ɵɵinterpolate(ctx.buttonUrl), i0.ɵɵsanitizeUrl);
        i0.ɵɵattribute("aria-label", ctx.settings.buttonLabel);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate1(" ", ctx.settings.buttonLabel, " ");
      }
    },
    dependencies: [StarComponent, i4.NgStyle, i4.NgIf, i4.NgForOf],
    styles: [_c2]
  });
  return NgxSmartBannerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxSmartBannerModule = /*#__PURE__*/(() => {
  class NgxSmartBannerModule {}
  NgxSmartBannerModule.ɵfac = function NgxSmartBannerModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxSmartBannerModule)();
  };
  NgxSmartBannerModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: NgxSmartBannerModule
  });
  NgxSmartBannerModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, PlatformModule]]
  });
  return NgxSmartBannerModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var NgxSmartBannerPlatform = /*#__PURE__*/function (NgxSmartBannerPlatform) {
  NgxSmartBannerPlatform["Android"] = "android";
  NgxSmartBannerPlatform["IOS"] = "ios";
  return NgxSmartBannerPlatform;
}(NgxSmartBannerPlatform || {});
let NgxSmartBannerService = /*#__PURE__*/(() => {
  class NgxSmartBannerService {
    constructor(platform, componentResolver, platformId, cookieService) {
      this.platform = platform;
      this.componentResolver = componentResolver;
      this.platformId = platformId;
      this.cookieService = cookieService;
      this.smartBanner = null;
      this.onOpen = new EventEmitter();
      this.onClose = new EventEmitter();
      this.isServer = isPlatformServer(this.platformId);
      this.settings = {
        title: 'Smart application',
        author: 'Smartbanner contributors',
        price: 'FREE',
        closeLabel: 'Close',
        buttonLabel: 'VIEW',
        enabledPlatforms: [NgxSmartBannerPlatform.Android, NgxSmartBannerPlatform.IOS],
        viewContainerRef: null,
        priceSuffix: {
          ios: ' - On the App Store',
          android: ' - In Google play'
        },
        rating: {
          ios: 2,
          android: 5
        },
        hideRating: false
      };
    }
    /**
     * Initializes ngx smart banner service
     *
     * @params settings
     */
    initialize(settings) {
      this.settings = Object.assign(Object.assign({}, this.settings), settings);
      if (!this.settings.viewContainerRef) {
        throw new Error('No view container ref provided');
      }
      if (this.isServer || this.cookieService.check('smartbanner_closed')) {
        return;
      }
      if (!this.platformEnabled) {
        return;
      }
      if (this.smartBanner === null) {
        const componentFactory = this.componentResolver.resolveComponentFactory(NgxSmartBannerComponent);
        const componentRef = this.settings.viewContainerRef.createComponent(componentFactory);
        this.onOpen.emit();
        componentRef.instance.componentRef = componentRef;
        this.smartBanner = componentRef.instance;
        this.onCloseSubscription$ = this.smartBanner.onClose.subscribe(() => {
          this.onClose.emit();
          this.onCloseSubscription$.unsubscribe();
        });
      }
      this.smartBanner.settings = this.settings;
    }
    /**
     * Determine if platform is enabled
     */
    get platformEnabled() {
      var _a, _b;
      if (this.platform.ANDROID) {
        return !!((_a = this.settings.enabledPlatforms) === null || _a === void 0 ? void 0 : _a.includes(NgxSmartBannerPlatform.Android));
      }
      if (this.platform.IOS) {
        return !!((_b = this.settings.enabledPlatforms) === null || _b === void 0 ? void 0 : _b.includes(NgxSmartBannerPlatform.IOS));
      }
      return false;
    }
  }
  NgxSmartBannerService.ɵfac = function NgxSmartBannerService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || NgxSmartBannerService)(i0.ɵɵinject(i1.Platform), i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(PLATFORM_ID), i0.ɵɵinject(CookieService));
  };
  NgxSmartBannerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: NgxSmartBannerService,
    factory: NgxSmartBannerService.ɵfac,
    providedIn: 'root'
  });
  return NgxSmartBannerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-smart-banner
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSmartBannerComponent, NgxSmartBannerModule, NgxSmartBannerPlatform, NgxSmartBannerService };
